export default __webpack_public_path__ + "static/project-slide-8-4032-2268-aae84b9995ab46c594629145acb4312e.webp";